import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

export const ModalDelete = ({ isOpen, handleCloseModal, onClick, dataDetail, isLoading }) => {
  if (!isOpen) return null;

  const { t } = useTranslation("common", "buttons");

  return (
    <Modal
      open={isOpen}
      title={t("Delete_Modal.Title")}
      onCancel={handleCloseModal}
      footer={() => (
        <>
          <Button type="primary" onClick={onClick} disabled={isLoading}>
            {t("BTN_Submit", { ns: "buttons" })}
          </Button>
          <Button onClick={handleCloseModal}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
        </>
      )}
    >
      {Array.isArray(dataDetail) ? (
        <h1>{`${t("Delete_Modal.Content")}`}</h1>
      ) : (
        <h1>{`${t("Delete_Modal.Content")} ${dataDetail?.id}`}</h1>
      )}
    </Modal>
  );
};
